"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RuleName;
(function (RuleName) {
    RuleName["NEGATIVE_FEEDBACK"] = "negative_feedback";
    RuleName["PRODUCT_FULFILLMENT"] = "product_fulfillment";
    RuleName["FEEDBACK_OFFER_ACCEPTED"] = "offer_accepted";
})(RuleName || (RuleName = {}));
exports.default = RuleName;
